/* Toy4You theme JS — v2 */
(function () {
  "use strict";
  var T = window.T4Y || { routes: {}, strings: {} };
  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var on = function (el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); };
  var debounce = function (fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; };

  function money(cents) {
    try {
      return (cents / 100).toLocaleString("en-IN", { style: "currency", currency: T.currency || "INR", maximumFractionDigits: 0 });
    } catch (e) { return "₹" + Math.round(cents / 100).toLocaleString("en-IN"); }
  }
  function deliveryRange(minDays, maxDays) {
    var minD = minDays != null ? minDays : (T.deliveryMin || 4);
    var maxD = maxDays != null ? maxDays : (T.deliveryMax || 5);
    if (maxD < minD) maxD = minD;
    function fmt(d) {
      var t = new Date();
      t.setHours(12, 0, 0, 0);
      t.setDate(t.getDate() + d);
      var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      return t.getDate() + " " + months[t.getMonth()];
    }
    var a = fmt(minD), b = fmt(maxD);
    return a === b ? a : a + " - " + b;
  }
  function etaHtml() {
    return '<span class="pcard__eta"><svg class="icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="2"/><circle cx="17" cy="18" r="2"/></svg> Estimated delivery: ' + deliveryRange() + "</span>";
  }
  function patchCardEtas(root) {
    $$(".pcard", root || document).forEach(function (card) {
      var eta = $(".pcard__eta", card);
      if (!eta) {
        var body = $(".pcard__body", card);
        if (body) body.insertAdjacentHTML("beforeend", etaHtml());
        return;
      }
      var txt = (eta.textContent || "").replace(/\s+/g, " ").trim();
      if (!txt || /Jan\s*5|5\s*Jan|Get it by\s*$/i.test(txt) || /Estimated delivery:\s*$/i.test(txt)) {
        eta.innerHTML = '<svg class="icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="2"/><circle cx="17" cy="18" r="2"/></svg> Estimated delivery: ' + deliveryRange();
      }
    });
  }
  function toast(msg, icon) {
    var el = $("[data-toast]"); if (!el) return;
    el.innerHTML = (icon !== false ? '<svg class="icon" viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M8 12l3 3 5-6"/></svg>' : "") + "<span>" + msg + "</span>";
    el.classList.add("is-on"); clearTimeout(el._t); el._t = setTimeout(function () { el.classList.remove("is-on"); }, 2600);
  }
  function lockScroll(lock) { document.body.classList.toggle("no-scroll", !!lock); }
  function trapFocus(container) {
    var f = $$('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])', container);
    if (f.length) f[0].focus();
  }

  /* ---------- Progress bar / back-to-top / header ---------- */
  var progress = document.createElement("div"); progress.className = "page-progress"; document.body.appendChild(progress);
  progress.style.width = "70%";
  on(window, "load", function () { progress.style.width = "100%"; setTimeout(function () { progress.style.opacity = "0"; }, 400); });

  var backTop = document.createElement("button"); backTop.type = "button"; backTop.className = "back-top"; backTop.setAttribute("aria-label", "Back to top");
  backTop.innerHTML = '<svg class="icon" viewBox="0 0 24 24"><path d="M12 19V5M6 11l6-6 6 6"/></svg>'; document.body.appendChild(backTop);
  on(backTop, "click", function () { window.scrollTo({ top: 0, behavior: reduceMotion ? "auto" : "smooth" }); });
  var header = $("[data-header]");
  // Shopify wraps sections in a div; make that wrapper the sticky element (fallback for browsers without :has()).
  if (header && header.parentElement && header.parentElement.classList.contains("shopify-section")) header.parentElement.classList.add("is-header-wrap");
  // Clean empty <li>/<p> left behind by imported product descriptions.
  $$(".rte li, .rte p").forEach(function (el) {
    if (!el.textContent.trim() && !el.querySelector("img, iframe, video, table")) el.remove();
  });
  $$(".rte ul, .rte ol").forEach(function (l) { if (!l.children.length) l.remove(); });
  function onScroll() {
    var y = window.scrollY || 0;
    if (header) header.classList.toggle("is-scrolled", y > 12);
    backTop.classList.toggle("is-visible", y > 520);
  }
  onScroll(); on(window, "scroll", onScroll, { passive: true });

  /* ---------- Announcement rotator ---------- */
  $$("[data-announce]").forEach(function (bar) {
    var msgs = $$(".announce__msg", bar); if (msgs.length < 2) return;
    var i = 0, ms = (parseInt(bar.getAttribute("data-interval"), 10) || 5) * 1000;
    setInterval(function () {
      var cur = msgs[i]; i = (i + 1) % msgs.length; var next = msgs[i];
      cur.classList.add("is-leaving"); cur.classList.remove("is-active");
      setTimeout(function () { cur.classList.remove("is-leaving"); }, 500);
      next.classList.add("is-active");
    }, ms);
  });

  /* ---------- Scroll reveal ---------- */
  function initReveal(root) {
    var els = $$("[data-reveal], [data-reveal-stagger]", root || document);
    if (reduceMotion || !("IntersectionObserver" in window)) { els.forEach(function (el) { el.classList.add("is-in"); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("is-in"); io.unobserve(en.target); } });
    }, { threshold: 0.1, rootMargin: "0px 0px -5% 0px" });
    els.forEach(function (el) { io.observe(el); });
  }
  initReveal();

  /* ---------- Count-up ---------- */
  $$("[data-count]").forEach(function (el) {
    var target = parseInt(el.getAttribute("data-count"), 10); if (!target || reduceMotion) return;
    var io = new IntersectionObserver(function (en) {
      if (!en[0].isIntersecting) return; io.disconnect();
      var start = performance.now(), dur = 1200;
      (function step(now) { var p = Math.min(1, (now - start) / dur); el.textContent = Math.round(target * (1 - Math.pow(1 - p, 3))); if (p < 1) requestAnimationFrame(step); })(start);
    }); io.observe(el);
  });

  /* ---------- Mobile menu drawer ---------- */
  var mega = $("[data-mega]");
  if (mega) {
    var openBtn = $("[data-mega-open]");
    function openMega() { mega.classList.add("open"); mega.setAttribute("aria-hidden", "false"); openBtn && openBtn.setAttribute("aria-expanded", "true"); lockScroll(true); trapFocus(mega); }
    function closeMega() { mega.classList.remove("open"); mega.setAttribute("aria-hidden", "true"); openBtn && openBtn.setAttribute("aria-expanded", "false"); lockScroll(false); }
    on(openBtn, "click", openMega);
    $$("[data-mega-close]", mega).forEach(function (el) { on(el, "click", closeMega); });
    $$("[data-mega-toggle]", mega).forEach(function (btn) {
      on(btn, "click", function () {
        var sub = btn.parentElement.nextElementSibling; var open = btn.getAttribute("aria-expanded") === "true";
        btn.setAttribute("aria-expanded", String(!open)); if (sub) sub.classList.toggle("is-open", !open);
      });
    });
    on(document, "keydown", function (e) { if (e.key === "Escape") closeMega(); });
  }

  /* ---------- Desktop nav (touch/keyboard open) ---------- */
  $$(".site-nav__item.has-children > .site-nav__link").forEach(function (link) {
    var item = link.parentElement;
    on(link, "click", function (e) {
      if (window.matchMedia("(hover: none)").matches || e.detail === 0) {
        if (!item.classList.contains("is-open")) { e.preventDefault(); $$(".site-nav__item.is-open").forEach(function (i) { i.classList.remove("is-open"); }); item.classList.add("is-open"); link.setAttribute("aria-expanded", "true"); }
      }
    });
    on(link, "keydown", function (e) { if (e.key === "ArrowDown") { e.preventDefault(); item.classList.add("is-open"); var f = $("a", $(".dropdown", item)); f && f.focus(); } });
  });
  on(document, "click", function (e) { if (!e.target.closest(".site-nav__item")) $$(".site-nav__item.is-open").forEach(function (i) { i.classList.remove("is-open"); }); });

  /* ---------- Header search panel (side icon → expand) ---------- */
  (function () {
    var panel = $("[data-search-panel]");
    var toggles = $$("[data-search-toggle]");
    if (!panel || !toggles.length) return;
    function setOpen(open) {
      panel.classList.toggle("is-open", open);
      if (open) panel.removeAttribute("hidden");
      else panel.setAttribute("hidden", "");
      toggles.forEach(function (btn) { btn.setAttribute("aria-expanded", open ? "true" : "false"); });
      if (open) {
        var input = $("[data-psearch-input]", panel);
        if (input) setTimeout(function () { input.focus(); }, 20);
      }
    }
    toggles.forEach(function (btn) {
      on(btn, "click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        setOpen(!panel.classList.contains("is-open"));
      });
    });
    on(document, "click", function (e) {
      if (!panel.classList.contains("is-open")) return;
      if (e.target.closest("[data-search-panel]") || e.target.closest("[data-search-toggle]")) return;
      setOpen(false);
    });
    on(document, "keydown", function (e) {
      if (e.key === "Escape" && panel.classList.contains("is-open")) setOpen(false);
    });
  })();

  /* ---------- Predictive search ---------- */
  (function () {
    var wrap = $("[data-search-wrap]"), input = $("[data-psearch-input]", wrap), panel = $("[data-psearch]", wrap);
    if (!wrap || !input || !panel) return;
    var prodBox = $("[data-psearch-products]", panel), popular = $("[data-psearch-popular]", panel), links = $("[data-psearch-links]", panel), all = $("[data-psearch-all]", panel);
    var defaultLinks = links.innerHTML;
    function open() { panel.classList.add("is-open"); }
    function close() { panel.classList.remove("is-open"); }
    on(input, "focus", open);
    on(document, "click", function (e) { if (!wrap.contains(e.target)) close(); });
    on(document, "keydown", function (e) { if (e.key === "Escape") close(); });
    var ctrl = null;
    var run = debounce(function () {
      var q = input.value.trim();
      if (q.length < 2) { prodBox.innerHTML = ""; prodBox.appendChild(popular); links.innerHTML = defaultLinks; all.hidden = true; return; }
      if (ctrl) ctrl.abort(); ctrl = new AbortController();
      prodBox.innerHTML = '<div class="skeleton" style="height:64px;margin-bottom:8px"></div><div class="skeleton" style="height:64px;margin-bottom:8px"></div><div class="skeleton" style="height:64px"></div>';
      var url = (T.routes.predictive || "/search/suggest") + ".json?q=" + encodeURIComponent(q) + "&resources[type]=product,page,collection&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag";
      fetch(url, { signal: ctrl.signal }).then(function (r) { return r.json(); }).then(function (d) {
        var res = (d.resources && d.resources.results) || {};
        var prods = res.products || [], pages = (res.pages || []).concat(res.collections || []);
        if (!prods.length) { prodBox.innerHTML = '<div class="psearch__empty">' + (T.strings.noResults || "No results") + "</div>"; }
        else {
          prodBox.innerHTML = prods.map(function (p) {
            var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url.replace(/(\.[a-z]+)(\?|$)/, "_120x120$1$2") + '" alt="" width="56" height="56">' : "<span></span>";
            var price = '<div class="price"><span class="now">' + money(Math.round(parseFloat(p.price) * 100)) + "</span></div>";
            return '<a class="psearch__item" href="' + p.url + '">' + img + "<strong>" + p.title + "</strong>" + price + "</a>";
          }).join("");
        }
        links.innerHTML = pages.length ? pages.map(function (pg) { return '<a href="' + pg.url + '">' + pg.title + "</a>"; }).join("") : defaultLinks;
        all.hidden = false; all.href = (T.routes.search || "/search") + "?q=" + encodeURIComponent(q) + "&type=product";
        all.textContent = (T.strings.viewAll || "View all results") + ' for "' + q + '" →';
      }).catch(function (e) { if (e.name !== "AbortError") prodBox.innerHTML = ""; });
    }, 220);
    on(input, "input", function () { open(); run(); });
    on(input, "keydown", function (e) {
      var items = $$(".psearch__item", panel); if (!items.length) return;
      var idx = items.findIndex(function (i) { return i.classList.contains("is-focus"); });
      if (e.key === "ArrowDown") { e.preventDefault(); items.forEach(function (i) { i.classList.remove("is-focus"); }); items[(idx + 1) % items.length].classList.add("is-focus"); }
      if (e.key === "ArrowUp") { e.preventDefault(); items.forEach(function (i) { i.classList.remove("is-focus"); }); items[(idx - 1 + items.length) % items.length].classList.add("is-focus"); }
      if (e.key === "Enter" && idx >= 0) { e.preventDefault(); location.href = items[idx].href; }
    });
  })();

  /* ---------- Hero slider ---------- */
  $$("[data-hero]").forEach(function (hero) {
    var slides = $$("[data-hero-slide]", hero), dots = $$("[data-hero-dot]", hero); if (slides.length < 2) return;
    var i = 0, delay = (parseInt(hero.getAttribute("data-autoplay"), 10) || 6) * 1000, timer;
    function go(n) {
      slides[i].classList.remove("is-active"); dots[i] && dots[i].classList.remove("is-active");
      i = (n + slides.length) % slides.length;
      slides[i].classList.add("is-active"); dots[i] && dots[i].classList.add("is-active");
    }
    function play() { if (reduceMotion) return; clearInterval(timer); timer = setInterval(function () { go(i + 1); }, delay); }
    on($("[data-hero-next]", hero), "click", function () { go(i + 1); play(); });
    on($("[data-hero-prev]", hero), "click", function () { go(i - 1); play(); });
    dots.forEach(function (d, n) { on(d, "click", function () { go(n); play(); }); });
    var sx = 0; on(hero, "touchstart", function (e) { sx = e.touches[0].clientX; }, { passive: true });
    on(hero, "touchend", function (e) { var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 50) { go(dx < 0 ? i + 1 : i - 1); play(); } });
    on(hero, "mouseenter", function () { clearInterval(timer); }); on(hero, "mouseleave", play);
    on(document, "visibilitychange", function () { document.hidden ? clearInterval(timer) : play(); });
    play();
  });

  /* ---------- Rails ---------- */
  $$("[data-rail]").forEach(function (rail) {
    var track = $("[data-rail-track]", rail); if (!track) return;
    var step = function () { return track.clientWidth * 0.8; };
    var scope = rail.parentElement;
    on($("[data-rail-prev]", scope), "click", function () { track.scrollBy({ left: -step(), behavior: "smooth" }); });
    on($("[data-rail-next]", scope), "click", function () { track.scrollBy({ left: step(), behavior: "smooth" }); });
  });

  /* ---------- Find it quick ---------- */
  (function () {
    var q = $("[data-quick]"); if (!q) return;
    var sel = { age: "3-6", type: "/collections/ride-on-cars", budget: "15000-25000", weight: "20-35", surface: "indoor" };
    var lbl = { age: "3–6 years", type: "Cars", budget: "₹15,000 – ₹25,000", weight: "20–35 kg", surface: "Indoor" };
    var tips = { "1-3": "Start with scooters or gentle 6V/12V rides.", "3-6": "12V cars and jeeps with parental remote are the sweet spot.", "6-10": "Look at 24V or roomier two-seaters for more power.", "10+": "Petrol dirt bikes and high-power 24V models fit bigger kids." };
    var surfaceTip = { indoor: "Flat floors — lower speed is safer.", society: "Smooth roads — 12V/24V with remote preferred.", garden: "Grass needs more torque — prefer 24V / jeeps.", rough: "Rough ground — jeeps, 24V or petrol rides." };
    function moneyInr(cents) { return "₹" + Math.round((cents || 0) / 100).toLocaleString("en-IN"); }
    /** Collection products.json puts price on variants[]; product.js uses cents on .price */
    function productPriceCents(p) {
      if (!p) return 0;
      if (typeof p.price === "number" && isFinite(p.price)) return p.price < 1000 ? Math.round(p.price * 100) : Math.round(p.price);
      if (typeof p.price === "string" && p.price !== "") return Math.round(parseFloat(p.price) * 100);
      if (typeof p.price_min === "number" && isFinite(p.price_min)) return Math.round(p.price_min);
      var v = p.variants && p.variants[0];
      if (v && v.price != null && v.price !== "") {
        if (typeof v.price === "number") return v.price < 1000 ? Math.round(v.price * 100) : Math.round(v.price);
        return Math.round(parseFloat(v.price) * 100);
      }
      return 0;
    }
    function productImage(p) {
      var img = p.featured_image || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || (p.image && (p.image.src || p.image)) || "";
      if (img && typeof img === "object") img = img.src || "";
      return String(img || "").replace(/^\/\//, "https://");
    }
    function update() {
      $("[data-quick-title]", q).textContent = "Best Matches for Your Child";
      $("[data-quick-text]", q).textContent = lbl.type + " · " + lbl.age + " · " + lbl.budget + " · " + lbl.weight + " · " + lbl.surface + ". " + (tips[sel.age] || "") + " " + (surfaceTip[sel.surface] || "");
      var b = (sel.budget || "0-999999").split("-");
      var link = $("[data-quick-link]", q);
      var ageCol = { "1-3": "/collections/ages-1-3", "3-6": "/collections/ages-3-5", "6-10": "/collections/ages-5-8", "10+": "/collections/petrol-bikes" };
      var matchSrc = ageCol[sel.age] || sel.type || "/collections/ride-on-cars";
      if (sel.surface === "rough" || sel.weight === "35+") {
        if (sel.type && sel.type.indexOf("jeep") > -1) matchSrc = sel.type;
        else if (sel.age === "10+") matchSrc = "/collections/petrol-bikes";
      }
      // Prefer ride-type collection as CTA when age band is thin, but keep age collection for matching
      var ctaSrc = matchSrc;
      if (sel.type && sel.type.indexOf("/collections/") === 0 && sel.age !== "10+" && !(sel.surface === "rough" || sel.weight === "35+")) {
        ctaSrc = sel.type;
      }
      if (ctaSrc.indexOf("/collections/") === 0) {
        link.href = ctaSrc + "?sort_by=price-ascending&filter.v.price.gte=" + b[0] + "&filter.v.price.lte=" + b[1];
      } else {
        link.href = ctaSrc;
      }
      var wa = $("[data-quick-wa]", q);
      if (wa) wa.href = "https://wa.me/" + T.whatsapp + "?text=" + encodeURIComponent("Hi Toy4You! Looking for " + lbl.type.toLowerCase() + " for a " + lbl.age + " old, budget " + lbl.budget + ", weight " + lbl.weight + ", surface " + lbl.surface + ". What do you recommend?");
      loadMatches(matchSrc, b[0], b[1], sel);
    }
    function loadMatches(href, minP, maxP, selState) {
      var box = $("[data-quick-matches]", q); if (!box) return;
      var path = (href || "").split("?")[0];
      var endpoint = path.indexOf("/collections/") === 0
        ? path + "/products.json?limit=50"
        : "/search/suggest.json?q=" + encodeURIComponent((new URL(href, location.origin)).searchParams.get("q") || "ride") + "&resources[type]=product&resources[limit]=10";
      fetch(endpoint).then(function (r) { return r.json(); }).then(function (data) {
        var products = data.products || (data.resources && data.resources.results && data.resources.results.products) || [];
        var minC = (parseInt(minP, 10) || 0) * 100;
        var maxC = (parseInt(maxP, 10) || 999999) * 100;
        products = products.filter(function (p) {
          var price = productPriceCents(p);
          if (!price || price < minC || price > maxC) return false;
          var tags = Array.isArray(p.tags) ? p.tags.join(" ") : (p.tags || "");
          var hay = ((p.title || "") + " " + tags + " " + (p.product_type || p.type || "")).toLowerCase();
          if (selState && selState.type) {
            if (selState.type.indexOf("bike") > -1 && !( /bike|scooter|cycle/.test(hay) )) return false;
            if (selState.type.indexOf("jeep") > -1 && !( /jeep|suv|utv/.test(hay) )) return false;
            if (selState.type.indexOf("scooter") > -1 && !( /scooter|scooty|vespa/.test(hay) )) return false;
            if (selState.type.indexOf("cars") > -1 && /spare|charger|remote|motor|battery charger/.test(hay) && !/car/.test(hay)) return false;
            if (selState.type.indexOf("cars") > -1 && /scooter|scooty|vespa|bike|tractor/.test(hay) && !/car|jeep/.test(hay)) return false;
          }
          return true;
        });
        if (!products.length) { box.hidden = true; box.innerHTML = ""; return; }
        box.hidden = false;
        box.innerHTML = products.slice(0, 6).map(function (p) {
          var img = productImage(p);
          var url = p.url || ("/products/" + p.handle);
          var price = productPriceCents(p);
          return '<a class="quick__match" href="' + url + '"><img src="' + img + '" alt="" loading="lazy" width="48" height="48"><div><strong>' + (p.title || "") + '</strong><span>' + moneyInr(price) + '</span></div></a>';
        }).join("");
      }).catch(function () { box.hidden = true; });
    }
    $$("[data-quick-group]", q).forEach(function (g) {
      var key = g.getAttribute("data-quick-group");
      var active = $(".quick__opt.is-active", g);
      if (active) { sel[key] = active.getAttribute("data-value"); lbl[key] = active.getAttribute("data-label"); }
      $$(".quick__opt", g).forEach(function (btn) {
        on(btn, "click", function () { $$(".quick__opt", g).forEach(function (x) { x.classList.remove("is-active"); }); btn.classList.add("is-active"); sel[key] = btn.getAttribute("data-value"); lbl[key] = btn.getAttribute("data-label"); update(); });
      });
    });
    update();
  })();

  /* ---------- Product finder modal ---------- */
  (function () {
    var modal = $("[data-finder-modal]"); if (!modal) return;
    function openFinder() {
      modal.hidden = false;
      document.documentElement.classList.add("is-finder-open");
      var closeBtn = $("[data-finder-close]", modal);
      if (closeBtn) closeBtn.focus();
    }
    function closeFinder() {
      modal.hidden = true;
      document.documentElement.classList.remove("is-finder-open");
    }
    on(document, "click", function (e) {
      if (e.target.closest("[data-finder-open]")) { e.preventDefault(); openFinder(); }
      if (e.target.closest("[data-finder-close]")) { e.preventDefault(); closeFinder(); }
    });
    on(document, "keydown", function (e) { if (e.key === "Escape" && !modal.hidden) closeFinder(); });
  })();

  /* ---------- Wishlist (local) ---------- */
  var WISH_KEY = "t4y_wish";
  function wishList() { try { return JSON.parse(localStorage.getItem(WISH_KEY) || "[]"); } catch (e) { return []; } }
  function syncWish() { var w = wishList(); $$("[data-wish]").forEach(function (b) { b.classList.toggle("is-on", w.indexOf(b.getAttribute("data-wish")) > -1); }); }
  on(document, "click", function (e) {
    var b = e.target.closest("[data-wish]"); if (!b) return; e.preventDefault();
    var h = b.getAttribute("data-wish"), w = wishList(), i = w.indexOf(h);
    if (i > -1) w.splice(i, 1); else w.push(h);
    localStorage.setItem(WISH_KEY, JSON.stringify(w)); syncWish(); toast(i > -1 ? "Removed from wishlist" : 'Saved · <a href="/pages/wishlist" style="color:inherit;text-decoration:underline">View wishlist</a>');
  });
  syncWish();

  /* ---------- Compare (up to 3, localStorage) ---------- */
  var CMP_KEY = "t4y_compare";
  function cmpList() { try { return JSON.parse(localStorage.getItem(CMP_KEY) || "[]"); } catch (e) { return []; } }
  function cmpSave(list) { localStorage.setItem(CMP_KEY, JSON.stringify(list.slice(0, 3))); renderCompare(); }
  function renderCompare() {
    var list = cmpList();
    var bar = $("[data-compare-bar]"); var slots = $("[data-compare-slots]"); var count = $("[data-compare-count]"); var openBtn = $("[data-compare-open]");
    $$("[data-compare]").forEach(function (b) { b.classList.toggle("is-on", list.some(function (x) { return x.handle === b.getAttribute("data-compare"); })); });
    if (!bar || !slots) return;
    bar.hidden = list.length === 0;
    if (count) count.textContent = String(list.length);
    if (openBtn) openBtn.disabled = list.length < 2;
    var html = "";
    for (var i = 0; i < 3; i++) {
      var item = list[i];
      if (item) html += '<div class="compare-bar__slot"><img src="' + (item.img || "") + '" alt=""><button type="button" data-compare-remove="' + item.handle + '" aria-label="Remove">×</button></div>';
      else html += '<div class="compare-bar__slot"></div>';
    }
    slots.innerHTML = html;
  }
  on(document, "click", function (e) {
    var rm = e.target.closest("[data-compare-remove]");
    if (rm) { e.preventDefault(); cmpSave(cmpList().filter(function (x) { return x.handle !== rm.getAttribute("data-compare-remove"); })); return; }
    var b = e.target.closest("[data-compare]"); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var handle = b.getAttribute("data-compare");
    var list = cmpList();
    var idx = list.findIndex(function (x) { return x.handle === handle; });
    if (idx > -1) list.splice(idx, 1);
    else {
      if (list.length >= 3) { toast("Compare up to 3 products", false); return; }
      list.push({ handle: handle, title: b.getAttribute("data-compare-title") || handle, img: b.getAttribute("data-compare-img") || "" });
    }
    cmpSave(list);
    toast(idx > -1 ? "Removed from compare" : "Added to compare");
  });
  on($("[data-compare-clear]"), "click", function () { cmpSave([]); });
  on($("[data-compare-close]"), "click", function () { var m = $("[data-compare-modal]"); if (m && m.close) m.close(); });
  on($("[data-compare-open]"), "click", function () {
    var modal = $("[data-compare-modal]"); var table = $("[data-compare-table]"); if (!modal || !table) return;
    var list = cmpList();
    if (list.length < 2) return;
    table.innerHTML = "<p class='hint'>Loading…</p>";
    if (modal.showModal) modal.showModal();
    Promise.all(list.map(function (item) { return fetch("/products/" + item.handle + ".js").then(function (r) { return r.json(); }); })).then(function (products) {
      function field(p, key) {
        var t = ((p.title || "") + " " + (p.tags || []).join(" ") + " " + (p.description || "").replace(/<[^>]+>/g, " ")).toLowerCase();
        if (key === "price") return money(p.price);
        if (key === "voltage") return /24v/.test(t) ? "24V" : (/6v/.test(t) ? "6V" : (/12v/.test(t) ? "12V" : "—"));
        if (key === "motors") return /4 motors?/.test(t) ? "4" : (/2 motors?/.test(t) ? "2" : "—");
        if (key === "age") { var m = t.match(/(\d\s*[–-]\s*\d+)\s*years?/); return m ? m[1].replace(/\s/g, "") + " yrs" : "—"; }
        if (key === "seats") return /2 seater|two seater|2 seats/.test(t) ? "2" : (/1 seater|single seat/.test(t) ? "1" : "—");
        if (key === "weight") { var w = t.match(/(\d+)\s*kg/); return w ? w[1] + " kg" : "—"; }
        if (key === "remote") return /remote|parental/.test(t) ? "Yes" : "—";
        if (key === "battery") return "—";
        if (key === "charge") { var c = t.match(/(\d+\s*[–-]\s*\d+)\s*hours?/); return c ? c[1] + " hrs" : "—"; }
        return "—";
      }
      var rows = [
        ["", "product"], ["Price", "price"], ["Voltage", "voltage"], ["Motors", "motors"], ["Age", "age"],
        ["Seats", "seats"], ["Maximum Weight", "weight"], ["Parental Remote", "remote"], ["Battery", "battery"], ["Charging Time", "charge"]
      ];
      var head = "<tr><th>Spec</th>" + products.map(function (p) {
        var img = (p.featured_image || "").replace(/^\/\//, "https://");
        return "<th><img src='" + img + "' alt=''><a href='/products/" + p.handle + "'>" + p.title + "</a></th>";
      }).join("") + "</tr>";
      var body = rows.slice(1).map(function (row) {
        return "<tr><th>" + row[0] + "</th>" + products.map(function (p) { return "<td>" + field(p, row[1]) + "</td>"; }).join("") + "</tr>";
      }).join("");
      table.innerHTML = "<div style='overflow:auto'><table class='compare-table'><thead>" + head + "</thead><tbody>" + body + "</tbody></table></div>";
    }).catch(function () { table.innerHTML = "<p class='hint'>Could not load products to compare.</p>"; });
  });
  renderCompare();

  /* ---------- Cart core ---------- */
  var drawer = $("[data-cart-drawer]");
  var cartState = null;
  function openDrawer() { if (!drawer) return; drawer.classList.add("open"); drawer.setAttribute("aria-hidden", "false"); lockScroll(true); var p = $(".cart-drawer__panel", drawer); p && p.focus(); }
  function closeDrawer() { if (!drawer) return; drawer.classList.remove("open"); drawer.setAttribute("aria-hidden", "true"); lockScroll(false); }
  $$("[data-cart-drawer-close]").forEach(function (el) { on(el, "click", closeDrawer); });
  $$("[data-cart-open]").forEach(function (el) { on(el, "click", function (e) { if (drawer && !document.body.classList.contains("template-cart")) { e.preventDefault(); refreshCart().then(openDrawer); } }); });
  on(document, "keydown", function (e) { if (e.key === "Escape") closeDrawer(); });

  function bounceCount() { $$("[data-cart-count]").forEach(function (el) { el.classList.remove("pop"); void el.offsetWidth; el.classList.add("pop"); }); }
  function renderShipbars(cart) {
    $$("[data-shipbar]").forEach(function (bar) {
      var fill = $("[data-shipbar-fill]", bar), txt = $("[data-shipbar-text]", bar), th = T.freeShipping || 199900;
      var left = th - cart.total_price, pct = Math.min(100, Math.round((cart.total_price / th) * 100));
      if (fill) fill.style.width = pct + "%";
      if (txt) txt.innerHTML = left > 0 ? (T.strings.shipAway || "Add {{ amount }} more for free delivery").replace("{{ amount }}", money(left)) : (T.strings.shipDone || "You've unlocked free delivery!");
      bar.classList.toggle("is-done", left <= 0);
    });
  }
  function lineHTML(item) {
    var variant = item.product_has_only_default_variant ? "" : '<div class="v">' + item.variant_title + "</div>";
    return '<div class="cart-drawer__line" data-key="' + item.key + '">' +
      (item.image ? '<a href="' + item.url + '"><img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/, "_160x160$1$2") + '" alt="" width="72" height="72"></a>' : "<div></div>") +
      '<div><a class="t" href="' + item.url + '">' + item.product_title + "</a>" + variant +
      '<div class="row"><div class="qty small" data-qty><button type="button" data-line-minus aria-label="Decrease">−</button><input type="number" value="' + item.quantity + '" min="0" max="10" data-line-input aria-label="Quantity"><button type="button" data-line-plus aria-label="Increase">+</button></div>' +
      '<div><span class="p">' + money(item.final_line_price) + '</span><button type="button" class="rm" data-line-rm>' + (T.strings.remove || "Remove") + "</button></div></div></div></div>";
  }
  function renderDrawer(cart) {
    if (!drawer) return;
    var body = $("[data-cart-drawer-items]", drawer), sub = $("[data-cart-drawer-subtotal]", drawer), cnt = $("[data-cart-drawer-count]", drawer);
    if (sub) sub.textContent = money(cart.total_price);
    if (cnt) cnt.textContent = cart.item_count ? "(" + cart.item_count + ")" : "";
    if (!body._empty) body._empty = body.innerHTML;
    if (!cart.items.length) body.innerHTML = body._empty;
    else body.innerHTML = cart.items.map(lineHTML).join("");
    var wa = $("[data-wa-cart]", drawer);
    if (wa && T.whatsapp) {
      var msg = "Hi Toy4You, I want to order:\n" + cart.items.map(function (i) { return "- " + i.product_title + (i.product_has_only_default_variant ? "" : " (" + i.variant_title + ")") + " × " + i.quantity; }).join("\n") + "\nTotal: " + money(cart.total_price);
      wa.href = "https://wa.me/" + T.whatsapp + "?text=" + encodeURIComponent(msg);
    }
  }
  function refreshCart() {
    return fetch(T.routes.cart ? T.routes.cart + ".js" : "/cart.js").then(function (r) { return r.json(); }).then(function (cart) {
      cartState = cart;
      $$("[data-cart-count]").forEach(function (el) { el.textContent = cart.item_count; el.style.display = cart.item_count > 0 ? "" : "none"; });
      renderShipbars(cart); renderDrawer(cart); return cart;
    });
  }
  function changeLine(key, qty, el) {
    if (el) el.classList.add("is-busy");
    return fetch((T.routes.cartChange || "/cart/change") + ".js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(function () { bounceCount(); return refreshCart(); });
  }
  function addToCart(items, fromEl) {
    var payload = Array.isArray(items) ? { items: items } : items;
    return fetch((T.routes.cartAdd || "/cart/add") + ".js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(payload) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || "Could not add"); return j; }); })
      .then(function (j) { if (fromEl) flyToCart(fromEl); bounceCount(); return refreshCart(); });
  }
  function flyToCart(fromEl) {
    if (reduceMotion) return;
    var img = fromEl.closest(".pcard") ? $(".pcard__media img", fromEl.closest(".pcard")) : $("#ProductMainImage");
    var cartBtn = $("[data-cart-open]"); if (!img || !cartBtn) return;
    var a = img.getBoundingClientRect(), b = cartBtn.getBoundingClientRect();
    var fly = img.cloneNode(); fly.className = "fly"; fly.style.left = a.left + a.width / 2 - 30 + "px"; fly.style.top = a.top + a.height / 2 - 30 + "px";
    document.body.appendChild(fly);
    requestAnimationFrame(function () { fly.style.left = b.left + b.width / 2 - 10 + "px"; fly.style.top = b.top + b.height / 2 - 10 + "px"; fly.style.width = fly.style.height = "20px"; fly.style.opacity = "0.2"; });
    setTimeout(function () { fly.remove(); }, 750);
  }
  // drawer line controls
  on(document, "click", function (e) {
    var line = e.target.closest(".cart-drawer__line"); if (!line) return;
    var input = $("[data-line-input]", line), key = line.getAttribute("data-key");
    if (e.target.closest("[data-line-plus]")) changeLine(key, Math.min(10, parseInt(input.value, 10) + 1), line);
    else if (e.target.closest("[data-line-minus]")) changeLine(key, Math.max(0, parseInt(input.value, 10) - 1), line);
    else if (e.target.closest("[data-line-rm]")) changeLine(key, 0, line);
  });
  on(document, "change", function (e) { var i = e.target.closest("[data-line-input]"); if (i) changeLine(i.closest(".cart-drawer__line").getAttribute("data-key"), Math.max(0, parseInt(i.value, 10) || 0), i.closest(".cart-drawer__line")); });

  // quick add from cards
  on(document, "click", function (e) {
    var b = e.target.closest("[data-quick-add]"); if (!b) return; e.preventDefault(); e.stopPropagation();
    b.classList.add("is-loading");
    addToCart({ id: parseInt(b.getAttribute("data-quick-add"), 10), quantity: 1 }, b).then(function () { toast(T.strings.added || "Added to cart"); openDrawer(); })
      .catch(function (err) { toast(err.message || "Could not add", false); }).finally(function () { b.classList.remove("is-loading"); });
  });
  on(document, "click", function (e) { var v = e.target.closest("[data-quick-view]"); if (v) { e.preventDefault(); location.href = v.getAttribute("data-quick-view"); } });

  // qty steppers (generic)
  on(document, "click", function (e) {
    var q = e.target.closest("[data-qty]"); if (!q || e.target.closest("[data-line-plus],[data-line-minus]")) return;
    var input = $("input", q); if (!input) return;
    var v = parseInt(input.value, 10) || 1, min = parseInt(input.min, 10) || 0, max = parseInt(input.max, 10) || 99;
    if (e.target.closest("[data-qty-plus]")) input.value = Math.min(max, v + 1);
    else if (e.target.closest("[data-qty-minus]")) input.value = Math.max(min, v - 1);
    else return;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  // initial cart state (shipbar on cart page etc.)
  if (drawer || $("[data-shipbar]")) refreshCart().catch(function () {});

  /* ---------- Cart page ---------- */
  (function () {
    var page = $("[data-cart-page]"); if (!page) return;
    var form = $("[data-cart-form]", page); if (!form) return;
    function reload() { location.reload(); }
    on(form, "change", function (e) {
      var i = e.target.closest("[data-line-qty]"); if (!i) return;
      var line = i.closest(".cart-line"); line.style.opacity = ".5";
      changeLine(line.getAttribute("data-key"), Math.max(0, parseInt(i.value, 10) || 0)).then(reload);
    });
    on(form, "click", function (e) {
      var r = e.target.closest("[data-line-remove]"); if (!r) return; e.preventDefault();
      var line = r.closest(".cart-line"); line.style.opacity = ".5";
      changeLine(line.getAttribute("data-key"), 0).then(reload);
    });
    var note = $("[data-cart-note]", form);
    on(note, "change", function () { fetch((T.routes.cartUpdate || "/cart/update") + ".js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ note: note.value }) }); });
  })();

  /* ---------- PDP ---------- */
  (function () {
    var pdp = $("[data-pdp]"); if (!pdp) return;
    var media = [], variants = [], productJson = null;
    try { media = JSON.parse($("#ProductMediaJson").textContent); variants = JSON.parse($("#ProductVariantsJson").textContent); productJson = JSON.parse($("#ProductJson").textContent); } catch (e) {}

    /* gallery */
    var stage = $("[data-stage]", pdp), main = $("#ProductMainImage"), thumbs = $$("[data-pdp-thumb]", pdp), dots = $$("[data-stage-dots] span", pdp), cur = 0;
    function show(n, instant) {
      if (!media.length || !main) return;
      cur = (n + media.length) % media.length;
      main.classList.add("is-swapping");
      setTimeout(function () { main.src = media[cur].src; main.removeAttribute("srcset"); main.alt = media[cur].alt || ""; main.classList.remove("is-swapping"); }, instant || reduceMotion ? 0 : 160);
      thumbs.forEach(function (t, i) { t.classList.toggle("is-active", i === cur); if (i === cur) t.scrollIntoView({ block: "nearest", inline: "nearest" }); });
      dots.forEach(function (d, i) { d.classList.toggle("is-active", i === cur); });
    }
    thumbs.forEach(function (t) { on(t, "click", function () { show(parseInt(t.getAttribute("data-index"), 10)); }); });
    on($("[data-stage-next]", pdp), "click", function (e) { e.stopPropagation(); show(cur + 1); });
    on($("[data-stage-prev]", pdp), "click", function (e) { e.stopPropagation(); show(cur - 1); });
    if (stage) {
      var sx = 0; on(stage, "touchstart", function (e) { sx = e.touches[0].clientX; }, { passive: true });
      on(stage, "touchend", function (e) { var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) show(dx < 0 ? cur + 1 : cur - 1); });
      var canHover = window.matchMedia("(hover: hover)").matches;
      if (canHover) {
        on(stage, "mousemove", function (e) { var r = stage.getBoundingClientRect(); stage.style.setProperty("--zx", ((e.clientX - r.left) / r.width) * 100 + "%"); stage.style.setProperty("--zy", ((e.clientY - r.top) / r.height) * 100 + "%"); stage.classList.add("is-zoom"); });
        on(stage, "mouseleave", function () { stage.classList.remove("is-zoom"); });
      }
      on(stage, "click", function (e) { if (e.target.closest("button")) return; openLightbox(cur); });
    }
    /* lightbox */
    var lb = $("[data-lightbox]"), lbImg = $("[data-lightbox-img]", lb), lbCount = $("[data-lightbox-count]", lb), lbi = 0;
    function lbShow(n) { lbi = (n + media.length) % media.length; lbImg.src = media[lbi].src; lbCount.textContent = (lbi + 1) + " / " + media.length; }
    function openLightbox(n) { if (!lb || !media.length) return; lbShow(n); lb.classList.add("is-open"); lb.setAttribute("aria-hidden", "false"); lockScroll(true); }
    function closeLightbox() { if (!lb) return; lb.classList.remove("is-open"); lb.setAttribute("aria-hidden", "true"); lockScroll(false); }
    on($("[data-lightbox-close]", lb), "click", closeLightbox);
    on($("[data-lightbox-next]", lb), "click", function () { lbShow(lbi + 1); });
    on($("[data-lightbox-prev]", lb), "click", function () { lbShow(lbi - 1); });
    on(lb, "click", function (e) { if (e.target === lb) closeLightbox(); });
    on(document, "keydown", function (e) { if (!lb || !lb.classList.contains("is-open")) return; if (e.key === "Escape") closeLightbox(); if (e.key === "ArrowRight") lbShow(lbi + 1); if (e.key === "ArrowLeft") lbShow(lbi - 1); });

    /* variants */
    var form = $("[data-product-form]", pdp), idInput = $("[data-variant-id]", form), addBtn = $('[name="add"]', form), priceBox = $("[data-product-price]", pdp), stockBox = $("[data-stock]", pdp);
    var stickyAdd = $("[data-sticky-add]"), stickyPrice = $("[data-sticky-price]");
    function selected() { return $$("[data-option-group]", form).map(function (g) { var c = $("input:checked", g); return c ? c.value : null; }); }
    function priceHTML(v, large) {
      var h = '<div class="price' + (large ? " price--lg" : "") + '"><span class="now">' + money(v.price) + "</span>";
      if (v.compare_at_price > v.price) { h += '<s class="mrp">' + money(v.compare_at_price) + "</s>"; if (large) h += '<span class="off">' + Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100) + "% off</span>"; }
      return h + "</div>";
    }
    function applyVariant(v) {
      if (!v) return;
      idInput.value = v.id;
      if (addBtn) { addBtn.disabled = !v.available; addBtn.innerHTML = '<svg class="icon" viewBox="0 0 24 24"><path d="M6 6h15l-1.5 9h-12z"/><circle cx="9" cy="20" r="1.5"/><circle cx="17" cy="20" r="1.5"/><path d="M6 6L5 3H2"/></svg> ' + (v.available ? addBtn.getAttribute("data-add-label") : addBtn.getAttribute("data-sold-label")); }
      if (stickyAdd) { stickyAdd.disabled = !v.available; stickyAdd.innerHTML = addBtn ? addBtn.innerHTML : ""; }
      if (priceBox) priceBox.innerHTML = priceHTML(v, true);
      if (stickyPrice) stickyPrice.innerHTML = priceHTML(v, false);
      if (stockBox) {
        var low = v.inventory_management && v.inventory_quantity > 0 && v.inventory_quantity <= 3;
        stockBox.className = "pdp__stock" + (!v.available ? " out" : low ? " low" : "");
        stockBox.innerHTML = '<span class="dot"></span>' + (!v.available ? "Currently out of stock" : low ? "Hurry! Only " + v.inventory_quantity + " left" : "In stock — ready to ship");
      }
      if (v.featured_media && v.featured_media.id) { var idx = media.findIndex(function (m) { return m.id === v.featured_media.id; }); if (idx > -1) show(idx); }
      $$("[data-option-group]", form).forEach(function (g, gi) { var lbl = $('[data-option-value="' + gi + '"]', pdp); var c = $("input:checked", g); if (lbl && c) lbl.textContent = c.value; });
      try { var u = new URL(location.href); u.searchParams.set("variant", v.id); history.replaceState(null, "", u); } catch (e) {}
      var wa = $("[data-wa-product]", pdp);
      if (wa && productJson) wa.href = "https://wa.me/" + T.whatsapp + "?text=" + encodeURIComponent("Hi Toy4You! I want to order: " + productJson.title + (v.title !== "Default Title" ? " (" + v.title + ")" : "") + " — " + location.href.split("?")[0]);
    }
    on(form, "change", function (e) {
      if (!e.target.closest("[data-option-input]")) return;
      var opts = selected();
      var v = variants.find(function (x) { return opts.every(function (o, i) { return x.options[i] === o; }); });
      $$(".opt-swatch, .opt-pill", form).forEach(function (l) { l.classList.toggle("is-active", !!$("input:checked", l)); });
      applyVariant(v);
    });
    // mark unavailable swatches for the first option
    (function () {
      var groups = $$("[data-option-group]", form); if (groups.length !== 1) return;
      $$("label", groups[0]).forEach(function (l) { var val = $("input", l).value; var any = variants.some(function (v) { return v.options[0] === val && v.available; }); l.classList.toggle("is-unavailable", !any); });
    })();

    /* add to cart (ajax) */
    function submitAdd(btn) {
      var qty = parseInt(($('[name="quantity"]', form) || {}).value, 10) || 1;
      btn.classList.add("is-loading");
      addToCart({ id: parseInt(idInput.value, 10), quantity: qty }, btn).then(function () { toast(T.strings.added || "Added to cart"); openDrawer(); })
        .catch(function (err) { toast(err.message || "Could not add to cart", false); }).finally(function () { btn.classList.remove("is-loading"); });
    }
    on(form, "submit", function (e) { if (!drawer) return; e.preventDefault(); submitAdd(addBtn); });
    on(stickyAdd, "click", function () { submitAdd(stickyAdd); });

    /* sticky ATC visibility */
    var sticky = $("[data-sticky-atc]");
    if (sticky && addBtn && "IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (en) { var vis = !en[0].isIntersecting && en[0].boundingClientRect.top < 0; sticky.classList.toggle("is-visible", vis); sticky.setAttribute("aria-hidden", String(!vis)); document.body.classList.toggle("has-sticky-atc", vis); });
      io.observe(addBtn);
    }

    /* pincode ETA — estimate from metro prefix (not live courier API) */
    var METRO = ["11", "12", "40", "41", "56", "60", "70", "50", "38", "30", "22", "24", "39"];
    on($("[data-pin-check]", pdp), "click", function () {
      var pin = ($("[data-pin-input]", pdp).value || "").trim(); var out = $("[data-eta-text]", pdp);
      if (!/^\d{6}$/.test(pin)) { out.innerHTML = "<strong style='color:var(--danger)'>Enter a valid 6-digit pincode</strong>"; return; }
      var metro = METRO.indexOf(pin.slice(0, 2)) > -1;
      var minD = T.deliveryMin || 4;
      var maxD = T.deliveryMax || 5;
      if (!metro) { minD = Math.min(minD + 1, maxD); }
      out.innerHTML = "Estimated delivery for <strong>" + pin + "</strong>: <strong>" + deliveryRange(minD, maxD) + "</strong>" + (metro ? " · COD often available" : " · COD depends on courier") + "<br><span style='font-size:12px;color:var(--muted)'>Final ETA confirmed at checkout after address</span>";
      localStorage.setItem("t4y_pin", pin);
    });
    var savedPin = localStorage.getItem("t4y_pin"); if (savedPin && $("[data-pin-input]", pdp)) { $("[data-pin-input]", pdp).value = savedPin; }

    /* Reviews: render JSON metafield string if Liquid could not iterate it */
    (function () {
      var list = $("[data-reviews-json]", pdp);
      if (!list) return;
      var raw = list.getAttribute("data-reviews-json");
      if (!raw || list.querySelector(".pdp-review")) return;
      var items;
      try { items = JSON.parse(raw); } catch (e) { return; }
      if (!Array.isArray(items) || !items.length) return;
      list.innerHTML = items.map(function (r) {
        var stars = Math.max(1, Math.min(5, parseInt(r.stars, 10) || 5));
        var starHtml = "";
        for (var i = 1; i <= 5; i++) starHtml += '<span class="' + (i <= stars ? "is-on" : "") + '"><svg class="icon" viewBox="0 0 24 24" aria-hidden="true" style="fill:currentColor;stroke:none"><path d="M12 2.5l2.9 6.2 6.6.8-4.9 4.6 1.3 6.6L12 17.5l-5.9 3.2 1.3-6.6L2.5 9.5l6.6-.8z"/></svg></span>';
        var initial = ((r.name || "P").trim().charAt(0) || "P").toUpperCase();
        return '<article class="pdp-review"><header class="pdp-review__head"><div class="pdp-review__avatar" aria-hidden="true">' + initial + '</div><div><strong class="pdp-review__name">' + (r.name || "Parent") + '</strong>' +
          (r.city ? '<span class="pdp-review__meta"> · ' + r.city + "</span>" : "") +
          (r.date ? '<span class="pdp-review__meta"> · ' + r.date + "</span>" : "") +
          '<div class="pdp-review__stars" aria-label="' + stars + ' out of 5">' + starHtml + "</div></div></header>" +
          (r.title ? '<h3 class="pdp-review__title">' + r.title + "</h3>" : "") +
          '<p class="pdp-review__body">' + (r.body || "") + "</p></article>";
      }).join("");
    })();

    /* copy link */
    on($("[data-copy-link]", pdp), "click", function (e) { var url = e.currentTarget.getAttribute("data-copy-link"); (navigator.clipboard ? navigator.clipboard.writeText(url) : Promise.reject()).then(function () { toast("Link copied"); }, function () { prompt("Copy link", url); }); });

    /* tabs + description auto-split */
    var tabs = $("[data-tabs]", pdp);
    if (tabs) {
      var desc = $("[data-description]", tabs), specsT = $("[data-specs-target]", tabs), boxT = $("[data-box-target]", tabs);
      if (desc) {
        // move spec tables to Specs tab
        $$("table", desc).forEach(function (t) {
          t.classList.add("spec-table");
          var prev = t.previousElementSibling;
          if (prev && /^H[1-6]$/.test(prev.tagName) && /spec|technical|detail/i.test(prev.textContent || "")) prev.remove();
          specsT.appendChild(t);
        });
        // find "in the box" / "package includes" heading and move following list
        $$("h1,h2,h3,h4,h5,strong,p", desc).forEach(function (h) {
          var txt = (h.textContent || "").toLowerCase();
          if (/(in the box|what.?s in the box|package (includes|contents)|box contents)/.test(txt) && txt.length < 60) {
            var next = h.nextElementSibling; var moved = [];
            while (next && /^(UL|OL|P)$/.test(next.tagName) && moved.length < 3) { moved.push(next); next = next.nextElementSibling; }
            if (moved.length) { h.remove(); moved.forEach(function (m) { boxT.appendChild(m); }); }
          }
        });
        // key: value lines → spec table
        if (!specsT.children.length) {
          var rows = [];
          $$("li, p", desc).forEach(function (el) { var m = (el.textContent || "").match(/^\s*([A-Za-z][A-Za-z /&()-]{2,32})\s*[:：]\s*(.{1,80})$/); if (m && el.children.length <= 1) { rows.push([m[1].trim(), m[2].trim()]); el.remove(); } });
          if (rows.length >= 3) { var tbl = document.createElement("table"); tbl.className = "spec-table"; tbl.innerHTML = rows.map(function (r) { return "<tr><td>" + r[0] + "</td><td>" + r[1] + "</td></tr>"; }).join(""); specsT.appendChild(tbl); }
        }
        $$("[data-tab-auto]", tabs).forEach(function (b) { var target = $('[data-panel="' + b.getAttribute("data-tab") + '"]', tabs); b.hidden = !(target && target.textContent.trim().length); });
        // strip empty paragraphs & inline styles from imported HTML
        $$("p", desc).forEach(function (p) { if (!p.textContent.trim() && !p.querySelector("img")) p.remove(); });
        $$("[style]", desc).forEach(function (el) { el.removeAttribute("style"); });
      }
      $$(".tabs__btn", tabs).forEach(function (b) {
        on(b, "click", function () {
          $$(".tabs__btn", tabs).forEach(function (x) { x.setAttribute("aria-selected", "false"); }); b.setAttribute("aria-selected", "true");
          $$(".tabs__panel", tabs).forEach(function (p) { p.classList.toggle("is-active", p.getAttribute("data-panel") === b.getAttribute("data-tab")); });
        });
      });
    }

    /* FBT */
    var fbt = $("[data-fbt]", pdp);
    if (fbt) {
      var total = $("[data-fbt-total]", fbt), base = parseInt(total.getAttribute("data-base"), 10) || 0;
      function calc() { var sum = base; $$("[data-fbt-item]:checked", fbt).forEach(function (c) { sum += parseInt(c.getAttribute("data-price"), 10) || 0; }); total.textContent = money(sum); }
      on(fbt, "change", calc);
      on($("[data-fbt-add]", fbt), "click", function (e) {
        var items = [{ id: parseInt(e.currentTarget.getAttribute("data-main"), 10), quantity: 1 }];
        $$("[data-fbt-item]:checked", fbt).forEach(function (c) { items.push({ id: parseInt(c.value, 10), quantity: 1 }); });
        e.currentTarget.classList.add("is-loading");
        addToCart(items, e.currentTarget).then(function () { toast("Added " + items.length + " items"); openDrawer(); }).catch(function (err) { toast(err.message, false); }).finally(function () { e.currentTarget && e.currentTarget.classList.remove("is-loading"); });
      });
    }

    /* recommendations */
    var rec = $("[data-recommendations]", pdp);
    if (rec && T.routes.recommendations) {
      fetch(T.routes.recommendations + "?section_id=main-product-recs&product_id=" + rec.getAttribute("data-product-id") + "&limit=" + (rec.getAttribute("data-limit") || 8) + "&intent=related")
        .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html"); var cards = $$(".pcard", doc);
          if (cards.length) {
            var t = $("[data-recommendations-target]", rec);
            t.innerHTML = "";
            cards.forEach(function (c) { t.appendChild(c); });
            syncWish();
            patchCardEtas(t);
            if (window.T4Y && typeof window.T4Y.renderCompare === "function") window.T4Y.renderCompare();
          }
        }).catch(function () {});
    }

    /* recently viewed */
    try {
      var KEY = "t4y_recent", list = JSON.parse(localStorage.getItem(KEY) || "[]"), handle = pdp.getAttribute("data-handle");
      var others = list.filter(function (h) { return h !== handle; }).slice(0, 8);
      localStorage.setItem(KEY, JSON.stringify([handle].concat(others).slice(0, 12)));
      var recent = $("[data-recent]", pdp), target = $("[data-recent-target]", pdp);
      if (recent && others.length) {
        Promise.all(others.slice(0, 6).map(function (h) { return fetch("/products/" + h + ".js").then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); })).then(function (ps) {
          ps = ps.filter(Boolean); if (!ps.length) return;
          target.innerHTML = ps.map(function (p) {
            var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/, "_600x450$1$2") : "";
            var h = p.handle || "";
            return '<article class="pcard pcard--sm" data-product-card data-handle="' + h + '"><a class="pcard__media" href="' + p.url + '"><img class="main" src="' + img + '" alt="" loading="lazy"></a>' +
              '<button type="button" class="pcard__compare" data-compare="' + h + '" data-compare-title="' + String(p.title || "").replace(/"/g, "&quot;") + '" data-compare-img="' + img + '" aria-label="Compare">Compare</button>' +
              '<div class="pcard__body"><h3 class="pcard__title"><a href="' + p.url + '">' + p.title + '</a></h3>' +
              '<div class="pcard__foot"><div class="price"><span class="now">' + money(p.price) + "</span>" + (p.compare_at_price > p.price ? '<s class="mrp">' + money(p.compare_at_price) + "</s>" : "") + '</div><a class="pcard__cta" href="' + p.url + '">View Details</a></div>' +
              etaHtml() + "</div></article>";
          }).join("");
          recent.hidden = false;
          patchCardEtas(target);
          if (window.T4Y && typeof window.T4Y.renderCompare === "function") window.T4Y.renderCompare();
        });
      }
    } catch (e) {}
  })();

  /* ---------- Collection page ---------- */
  (function () {
    var sort = $("[data-sort-select]");
    on(sort, "change", function () { var u = new URL(location.href); u.searchParams.set("sort_by", sort.value); u.searchParams.delete("page"); location.href = u.toString(); });
    var filterForm = $("[data-filter-form]");
    on(filterForm, "change", function (e) { if (e.target.matches("[data-filter-auto]")) filterForm.submit(); });
    var fd = $("[data-filter-drawer]"), src = $("[data-filters-source]");
    if (fd && src) {
      var body = $("[data-filter-drawer-body]", fd), cloned = false;
      function openF() { if (!cloned) { body.innerHTML = src.innerHTML; cloned = true; var f = $("form", body); if (f) { $$("[data-filter-auto]", f).forEach(function (i) { i.removeAttribute("data-filter-auto"); }); } } fd.classList.add("open"); fd.setAttribute("aria-hidden", "false"); lockScroll(true); }
      function closeF() { fd.classList.remove("open"); fd.setAttribute("aria-hidden", "true"); lockScroll(false); }
      on($("[data-filter-open]"), "click", openF);
      $$("[data-filter-close]", fd).forEach(function (b) { on(b, "click", closeF); });
      on($("[data-filter-apply]", fd), "click", function () { var f = $("form", body); if (f) f.submit(); });
    }
    var clamp = $("[data-clamp]"), tog = $("[data-clamp-toggle]");
    if (clamp && tog) { if (clamp.scrollHeight <= 240) { clamp.classList.remove("is-clamped"); tog.hidden = true; } on(tog, "click", function () { var c = clamp.classList.toggle("is-clamped"); tog.firstChild.textContent = c ? "Read more " : "Read less "; }); }
  })();

  /* ---------- Page TOC ---------- */
  (function () {
    var toc = $("[data-toc]"), src = $("[data-toc-source]"); if (!toc || !src) return;
    var hs = $$("h2, h3", src).filter(function (h) { return h.textContent.trim().length > 2; }); if (hs.length < 3) return;
    hs.forEach(function (h, i) { if (!h.id) h.id = "s-" + i + "-" + h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, "-").slice(0, 40); var a = document.createElement("a"); a.href = "#" + h.id; a.textContent = h.textContent.trim(); if (h.tagName === "H3") a.style.paddingLeft = "22px"; toc.appendChild(a); });
    toc.hidden = false;
    if ("IntersectionObserver" in window) { var io = new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) { $$("a", toc).forEach(function (a) { a.classList.toggle("is-active", a.getAttribute("href") === "#" + e.target.id); }); } }); }, { rootMargin: "-20% 0px -70% 0px" }); hs.forEach(function (h) { io.observe(h); }); }
  })();

  /* ---------- Address country/province ---------- */
  $$("[data-address-country]").forEach(function (country) {
    var prov = country.closest("form").querySelector("[data-address-province]"); if (!prov) return;
    function fill() {
      var opt = country.options[country.selectedIndex]; var raw = opt ? opt.getAttribute("data-provinces") : "[]"; var list = [];
      try { list = JSON.parse(raw); } catch (e) {}
      prov.innerHTML = list.map(function (p) { return '<option value="' + p[0] + '">' + p[1] + "</option>"; }).join("");
      prov.closest("label").style.display = list.length ? "" : "none";
      var def = prov.getAttribute("data-default"); if (def) prov.value = def;
    }
    var def = country.getAttribute("data-default"); if (def) country.value = def;
    on(country, "change", fill); fill();
  });

  /* ---------- Newsletter inline success scroll ---------- */
  if (location.hash === "#FooterNewsletter" || (location.search.indexOf("customer_posted=true") > -1)) { var nl = $("#FooterNewsletter"); nl && nl.scrollIntoView({ block: "center" }); }

  /* ---------- Expose ---------- */
  window.T4Y.cart = { refresh: refreshCart, add: addToCart, open: openDrawer, close: closeDrawer };
  window.T4Y.toast = toast;
  window.T4Y.renderCompare = renderCompare;
  window.T4Y.patchCardEtas = patchCardEtas;
  window.T4Y.deliveryRange = deliveryRange;
  patchCardEtas(document);
})();
